import type { SagaIterator } from "redux-saga";
import { all, call, put, takeLatest } from "redux-saga/effects";
import type { ActionType } from "typesafe-actions";

import * as drawingsApi from "@/shop/api/drawings";
import type { DrawingHotspotsResponse, DrawingPartInformationFetchResults } from "@/shop/types/drawings";

import * as DrawingActions from "./actions";
import type { DrawingDetails } from "./types";

function* updateDrawingState(action: ActionType<typeof DrawingActions.updateClickableDrawingsState>): SagaIterator {
  try {
    // reset - the location has changed
    yield put(DrawingActions.resetClickableDrawingsState());

    const assemblyGroupSku = action.payload;

    // update machine sku
    yield put(DrawingActions.updateCurrentMachineSuccess(assemblyGroupSku));

    yield all([
      call(function* () {
        // part information
        yield put(DrawingActions.fetchDrawingPartInformationStart());
        const drawingPartInformation: DrawingPartInformationFetchResults = yield call(drawingsApi.fetchDrawingPartInformationCached, assemblyGroupSku);
        yield put(DrawingActions.fetchDrawingPartInformationSuccess(drawingPartInformation));
      }),
      call(function* () {
        try {
          yield put(DrawingActions.fetchDrawingDetails());
          yield put(DrawingActions.fetchDrawingCoordinatesStart());
          const drawingHotspots: DrawingHotspotsResponse = yield call(drawingsApi.fetchDrawingHotspotsCached, assemblyGroupSku);
          yield put(DrawingActions.fetchDrawingCoordinatesSuccess(drawingHotspots.coordinates));
          const drawingDetails: DrawingDetails = yield call(drawingsApi.loadDrawingImage, drawingHotspots.image);
          yield put(DrawingActions.fetchDrawingDetailsSuccess(drawingDetails));
        } catch (error) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          yield put(DrawingActions.fetchDrawingDetailsFail(error));
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          yield put(DrawingActions.fetchDrawingCoordinatesFail(error));
        }
      })
    ]);
  } catch (err) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    yield put(DrawingActions.updateCurrentMachineFail(err));
  }
}

export default function* drawingSaga(): SagaIterator {
  yield takeLatest(DrawingActions.updateClickableDrawingsState, updateDrawingState);
}
